import createLucideIcon from '../createLucideIcon';

const MonitorPause = createLucideIcon('MonitorPause', [
  ['path', { d: 'M10 13V7', key: '1u13u9' }],
  ['path', { d: 'M14 13V7', key: '1vj9om' }],
  [
    'rect',
    { width: '20', height: '14', x: '2', y: '3', rx: '2', key: '48i651' },
  ],
  ['path', { d: 'M12 17v4', key: '1riwvh' }],
  ['path', { d: 'M8 21h8', key: '1ev6f3' }],
]);

export default MonitorPause;
